import DefaultInfoCard from "./DefaultInfoCard";

const CardImage = ({ imageUrl, alt }) => {
	return (
		<div className="w-full h-[300px] overflow-hidden rounded-t-[32px]">
			<img
				src={imageUrl}
				alt={alt}
				className="w-full h-full object-cover object-top block"
				style={{ aspectRatio: "auto 370 / 300" }}
			/>
		</div>
	);
};

const CardFooter = ({ title, content }) => {
	return (
		<div className={`h-full px-6 pb-6`}>
			<h3 className="text-center !text-lg text-is2-gray-700">{title}</h3>
			<div className="text-center [&_p]:text-is2-gray-150 pt-0">{content}</div>
		</div>
	);
};

export const CarouselCard = ({
	imageUrl,
	imageAlt,
	title,
	headerText,
	subtitle,
	content,
	formattedSectionStyles,
}) => {
	return (
		<div
			className={`w-[340px] lg:w-[364px] h-full [&>article]:rounded-[32px] [&>article]:p-0 [&>article]:pb-8 [&>article]:flex [&>article]:flex-col [&>article]:gap-4 [&>article]:h-full`}
		>
			<DefaultInfoCard
				content={null}
				imageComponent={<CardImage imageUrl={imageUrl} imageAlt={imageAlt} />}
				footerComponent={<CardFooter title={headerText ?? title} subtitle={subtitle} content={content} />}
				formattedSectionStyles={formattedSectionStyles}
			/>
		</div>
	);
};
